// Import the functions you need from the SDKs you need
import { Injectable } from "@angular/core";
import { FirebaseApp, initializeApp } from "firebase/app";
import { FirebaseAuth } from "./firebaseauth";
import { FirebaseFirestore } from "./firebasefs";
import { FirebasePortal } from "./firebaseportal";
import { FirebaseAppCheck } from "./firebaseappcheck";

// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries


@Injectable({
  providedIn: 'root'
})
export class FirebaseInit {

  private _app!: FirebaseApp;
  private fauth!: FirebaseAuth;
  private fstore!: FirebaseFirestore;
  //private fstorage!: FirebaseStore;
  private fportal!: FirebasePortal;
  private fappcheck!: FirebaseAppCheck;

  private firebaseConfig!: any;

  private constructor() {

  }

  public setupConfig(config: any) {
    this.firebaseConfig = config;
  }

  private setup() {
    //MLLog.logDev("this.firebaseConfig ", this.firebaseConfig)
    this._app = initializeApp(this.firebaseConfig);
    this.fauth = new FirebaseAuth(this._app);
    this.fstore = new FirebaseFirestore(this._app, this.fauth);
    //this.fstorage = new FirebaseStore(this._app);
    this.fportal = new FirebasePortal(this._app, this.fauth);
    if (this.firebaseConfig.recaptchaSiteKey) {
      this.fappcheck = new FirebaseAppCheck(this._app, this.firebaseConfig)
    }

  }

  public get app(): FirebaseApp {
    if (this._app == null || this._app == undefined) {
      this.setup();
    }
    return this._app;
  }

  public get f_auth(): FirebaseAuth {
    if (this._app == null || this._app == undefined) {
      this.setup();
    }
    return this.fauth;
  }

  public get f_store(): FirebaseFirestore {
    if (this._app == null || this._app == undefined) {
      this.setup();
    }
    return this.fstore;
  }

  public get f_check(): FirebaseAppCheck {
    if (this._app == null || this._app == undefined) {
      this.setup();
    }
    return this.fappcheck;
  }

  /*
    public get f_storage(): FirebaseStore {
      if (this._app == null || this._app == undefined) {
        this.setup();
      }
      return this.fstorage;
    }
  */
  public get f_portal(): FirebasePortal {
    if (this._app == null || this._app == undefined) {
      this.setup();
    }
    return this.fportal;
  }
}